export default __webpack_public_path__ + "static/media/img--interiors-2.24d90e48.jpg";